import { AsyncPipe } from '@angular/common';
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TagModule } from 'primeng/tag';
import { BehaviorSubject, Observable } from 'rxjs';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'lib-scope-type-tag',
  template: `
    @if ({ row: columnData | async }; as $) {
      <p-tag [value]="'COMMISSION_MANAGEMENT.SCOPE_TYPES.' + ($.row?.scope_type || '')?.toUpperCase() | translate"
      severity="warning" />
    }
    `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [TagModule, TranslateModule, AsyncPipe]
})
export class ScopeTypeTagComponent {
  columnData: Observable<any> = new BehaviorSubject<any>(null);
  additionData: Observable<any> = new BehaviorSubject<any>(null);
}


